<template>
  <div
    class="loading"
    :class="sizeModifier"
  >
    <i
      aria-hidden="true"
      class="fas fa-spinner loading__spinner"
    />
  </div>
</template>

<script>

const sizes = {
  UNDEFINED: 'undefined',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
};

export default {
  props: {
    /**
     * Tamanho.
     * Opcional, Padrão não definido, que segue o font-size do container.
     *
     * Valores possíveis:
     * small/sm, medium/md, large/lg
     */
    size: {
      type: String,
      required: false,
      default: sizes.UNDEFINED,
    },
  },
  computed: {
    sizeModifier() {
      return `loading_${this.size}`;
    },
  },
};
</script>


<style lang="sass" scoped>
$spin: spin
.loading
  display: flex
  align-items: center
  justify-content: center
  &_small,
  &_sm
    font-size: 1rem
  &_medium,
  &_md
    font-size: 2rem
  &_large,
  &_lg
    font-size: 3.5rem
  &__spinner
    -webkit-animation: spin 1s infinite steps(8)
    -moz-animation: spin 1s infinite steps(8)
    animation: spin 1s infinite steps(8)

@keyframes spin
  0%
    transform: rotate(-360deg)
  100%
    transform: rotate(0deg)

</style>
